export default "__VITE_ASSET__BjX9sX44__"